<template>
	<div class="sch-times">
		<div class="sch-timesList sch-timesList_eqip">
			<div
				:class="getClass(item)"
				v-for="(item, key) in items"
				:key="item.id"
				@click="select(item)"
				:title="item.name"
			>
				{{ key + 1 }}
			</div>
		</div>
		<div class="sch-timesLegend">
			<div class="icon icon_reserved"></div>
			- занято
		</div>
		<div class="sch-timesLegend">
			<div class="icon icon_free"></div>
			- свободно
		</div>
		<div class="form" v-if="list.length > 0">
			<div class="form-buttons">
				<div class="form-buttonsItem">
					<div class="button" @click="submit"><span>Забронировать</span></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['items', 'equipments_id'],
	data() {
		return {
			list: [],
		};
	},
	methods: {
		getClass(item) {
			let list = ['sch-timesEquip'];
			if (item.full) list.push('sch-timesEquip_closed');
			if (this.list.indexOf(item.id) !== -1) list.push('sch-timesEquip_selected');
			return list;
		},
		select(item) {
			if (item.full) return;

			let input = this.list;
			if (input.indexOf(item.id) !== -1) {
				input.splice(input.indexOf(item.id), 1);
			} else {
				input.push(item.id);
			}
		},
		submit() {
			this.$emit('input', this.list);
		},
	},
	watch: {
		items() {
			this.list.splice(0);
		}
	}
};
</script>
